export async function downloadImage(url: string, filename?: string): Promise<void> {
  const fallbackName =
    filename || decodeURIComponent(url.split('/').pop() || 'image').split('?')[0]

  try {
    const response = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    const blob = await response.blob()

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    if (isMobile && navigator.canShare) {
      const mimeType = blob.type || 'image/jpeg'
      const file = new File([blob], fallbackName, { type: mimeType })
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file] })
        return
      }
    }

    const blobUrl = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fallbackName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
  } catch (err) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
